import { render, staticRenderFns } from "./EditNameDialog.vue?vue&type=template&id=77e40469&scoped=true&"
import script from "./EditNameDialog.vue?vue&type=script&lang=js&"
export * from "./EditNameDialog.vue?vue&type=script&lang=js&"
import style0 from "./EditNameDialog.vue?vue&type=style&index=0&id=77e40469&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77e40469",
  null
  
)

export default component.exports